// components/TaskDetails.js
import React from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";

const TaskDetails = ({ task }) => {
  if (!task) {
    return (
      <Card className="mt-3">
        <Card.Body>
          <Card.Text>タスクを選択してください。</Card.Text>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mt-3">
      <Card.Body>
        <Card.Title className="mb-4">{task.title}</Card.Title>
        <Row>
          <Col md={6} sm={12} className="mb-2">
            <strong>詳細:</strong>
            <div>{task.details || "詳細がありません。"}</div>
          </Col>
          <Col md={6} sm={12} className="mb-2">
            <strong>締め切り:</strong>
            <div>
              {task.deadline
                ? new Date(task.deadline).toLocaleString()
                : "設定なし"}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6} sm={12} className="mb-2">
            <strong>タグ:</strong>
            <div>
              {task.tags.length > 0
                ? task.tags.map((tag) => (
                    <Badge bg="info" key={tag} className="me-1">
                      {tag}
                    </Badge>
                  ))
                : "なし"}
            </div>
          </Col>
          <Col md={3} sm={6} className="mb-2">
            <strong>優先度:</strong>
            <div>
              <Badge bg={getPriorityBadgeClass(task.priority)}>
                {getPriorityLabel(task.priority)}
              </Badge>
            </div>
          </Col>
          <Col md={3} sm={6} className="mb-2">
            <strong>ステータス:</strong>
            <div>
              <Badge bg={task.completed ? "success" : "secondary"}>
                {task.completed ? "完了" : "未完了"}
              </Badge>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

// 優先度ラベルの取得
const getPriorityLabel = (priority) => {
  switch (priority) {
    case "high":
      return "高";
    case "medium":
      return "中";
    case "low":
      return "低";
    default:
      return "";
  }
};

// 優先度バッジのクラス取得
const getPriorityBadgeClass = (priority) => {
  switch (priority) {
    case "high":
      return "danger";
    case "medium":
      return "warning";
    case "low":
      return "success";
    default:
      return "secondary";
  }
};

export default TaskDetails;
